import { handleSaveEvent } from "../../../js/components/save-community";
import { openCompareWidget, closeCompareWidget } from "../../../js/components/compare-community";
import { removeFromCompare, toggleCompare } from '../../../js/api/compare';
import { isLocalhost } from '../../../js/modules/utilities';

// eslint-disable-next-line import/prefer-default-export
export const compareCommunities = () => {
  const maxCompare = 5;
  const compareCount = document.querySelector('.compare-communities__header--count');

  const compareWrapper = document.querySelector('.compare-communities');
  const compareOverlay = document.querySelector('.compare-overlay');
  const closeCompare = document.querySelector('.close-compare');
  const viewList = document.querySelectorAll('.view-list');

  const viewedList = document.querySelector('#viewed-list .community-list');
  const savedList = document.querySelector('#saved-list .community-list');
  const compareList = document.querySelector('.compare-communities__list .community-list');

  const clearAll = document.querySelectorAll('.clear-compare');
  const viewCompare = document.querySelector('.view-compare');
  const toTop = document.querySelectorAll('.to-top');

  const compareManageUrl = '/maa-api/compare/v1/';

  // const handleOpen = (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   compareWrapper.classList.remove('collapsed');
  //   compareOverlay.classList.remove('collapsed');
  // };

  // const handleClose = (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   compareWrapper.classList.add('collapsed');
  //   compareOverlay.classList.add('collapsed');
  // };

  const handleClick = ((e) => {
    e.preventDefault();
    const anchor = e.target.closest("a");
    if (!anchor) return;
    const pdpLink = anchor.getAttribute("href");
    window.location.href = pdpLink;
  });

  const buildListItem = ((property, isInitial = true) => {
    const li = document.createElement('li');
    li.classList.add('community-list__item');
    li.setAttribute('data-id', property.Id);

    const { Neighborhood, PropertyName } = property;
    const item = document.createElement('a');
    item.classList.add('community-list__item--link');
    item.setAttribute('href', property.Url);
    item.innerHTML = `
      <img src="${property.Image}" alt="${property.PropertyName}"/>
      <div class="community-list__item--detail">
        ${Neighborhood ? `<div class="detail-area">${Neighborhood}</div>` : ''}
        ${PropertyName ? `<div class="detail-name">${PropertyName}</div>` : ''}
      </div>
    `;
    item.addEventListener('click', handleClick);

    const saveLink = document.createElement('a');
    saveLink.classList.add('community-list__item--favorite');
    saveLink.setAttribute('data-id', property.Id);
    saveLink.setAttribute('href', '#save');
    saveLink.innerHTML = '<svg class="saved-items"><use xlink:href="#saved-items"></use></svg>';
    if (!isInitial) {
      bindEvent(saveLink, 'click', handleSaveEvent);
    }

    if (property.IsSaved) saveLink.classList.add('saved');

    const removeLink = document.createElement('a');
    removeLink.classList.add('community-list__item--remove');
    removeLink.setAttribute('data-id', property.Id);
    removeLink.setAttribute('href','#remove');
    removeLink.innerHTML = '<svg class="close"><use xlink:href="#close"></use></svg>';
    if (!isInitial) {
      bindEvent(removeLink, 'click', handleRemove);
    }

    const addLink = document.createElement('a');
    addLink.classList.add('community-list__item--add');
    addLink.setAttribute('data-id', property.Id);
    addLink.setAttribute('href','#add');
    addLink.innerHTML = '<svg class="add"><use xlink:href="#add"></use></svg>';

    const added = document.createElement('div');
    added.classList.add('community-list__item--added');
    added.innerHTML = '<svg class="checkmark"><use xlink:href="#checkmark"></use></svg>Added to Compare';

    if(property.IsCompare) li.classList.add('added');

    li.appendChild(item);
    li.appendChild(saveLink);
    li.appendChild(removeLink);
    li.appendChild(addLink);
    li.appendChild(added);

    return li;
  });


  const bindEvent = (target, evt, act) => {
    target.addEventListener(evt, act);
  }

  const updateCompareCount = () => {
    compareCount.textContent = compareList.getAttribute('data-count') + ' of ' + maxCompare;
  };

  const updatePropCount = () => {
    const propCount = compareList.children.length;
    viewCompare.classList.toggle('valid', propCount > 1);
    document.querySelectorAll('.compare-communities__add--list').forEach((item) => {
      item.classList.toggle('not-available', propCount >= 5);
    });

    if(propCount <= maxCompare){
      compareList.setAttribute('data-count', propCount);
      updateCompareCount();
    }
  };

  const removeCompareItem = ((target, itemId) => {
    const dataCommunity = '[data-id="' + itemId + '"].added';
    document.querySelectorAll(dataCommunity).forEach((el) => {
      el.classList.remove('added');
    })

    const communityIndex = communitiesArray && communitiesArray.communities && communitiesArray.communities.findIndex( obj => {
      return obj.Id === itemId;
    });

    if (communityIndex > -1) {
      communitiesArray.communities[communityIndex].IsCompare = false;
    }

    if (isLocalhost()) {
      toggleCompare(itemId);
      if (target) {
        target.remove();
      }
      updatePropCount();
    } else {
      fetch(compareManageUrl + itemId, {
        method: 'DELETE',
      })
        .then(_ => {
          toggleCompare(itemId);
          if (target) {
            target.remove();
          }
          updatePropCount();
        });
    }
  });

  const handleRemove = ((e) => {
    e.preventDefault();
    const target = e.currentTarget.closest('.community-list__item');
    const communityIndex = e.currentTarget.getAttribute('data-id');
    removeCompareItem(target, communityIndex);
  });

  const handleTop = (e) => {
    e.preventDefault();
    document.querySelector('.compare-communities').scrollTop = 0;
  }

  toTop.forEach((item) => {
    item.addEventListener('click', handleTop);
  });

  if(compareWrapper){
    compareWrapper.addEventListener('click', openCompareWidget);
    closeCompare.addEventListener('click', closeCompareWidget);
    compareOverlay.addEventListener('click', closeCompareWidget);

    const handleView = (e) => {
      e.preventDefault();
      document.querySelector('.view-list.active').classList.remove('active');
      document.querySelector('.compare-communities__add--list.active').classList.remove('active');
      const target = e.target.getAttribute('href');
      e.target.classList.add('active');
      document.querySelector(target).classList.add('active');
    };

    viewList.forEach((item) => {
      item.addEventListener('click', handleView);
    });

    const log = ((mutations) => {
      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          updatePropCount();
        }
      }
    });

    let observer = new MutationObserver(log);

    observer.observe(compareList, {
        childList: true
    });

    const handleClear = ((e) => {
      e.preventDefault();
      // [].slice.call(compareList.children).forEach((item) => {
      //   removeCompareItem(item);
      // });
      compareList.querySelectorAll('.community-list__item').forEach((item) => {
        removeCompareItem(item, item.getAttribute('data-id'));
      })
    });

    clearAll.forEach(clear => clear.addEventListener('click', handleClear));

    const compareView = (e) => {
      console.log('clicked');
      if(!e.currentTarget.classList.contains('valid')){
        console.log('not going');
        e.preventDefault();
      } else {
        window.location.href = e.currentTarget.getAttribute('href');
      }
    }

    viewCompare.addEventListener('click', compareView);

    const handleAdd = ((e) => {
      e.preventDefault();
      const target = e.currentTarget.closest('.community-list__item');
      const compareItem = target.cloneNode(true);
      const communityId = e.currentTarget.getAttribute('data-id');
      compareItem.querySelector('[href="#remove"]').addEventListener('click', handleRemove);
      compareItem.querySelector('[href="#save"]').addEventListener('click', handleSaveEvent);
      compareList.appendChild(compareItem);
      document.querySelectorAll('[data-id="' + communityId + '"]').forEach((item) => {
        item.classList.toggle('added');
      });

      if (communitiesArray && communitiesArray.communities) {
        const communityIndex = communitiesArray.communities.findIndex( obj => {
          return obj.Id === communityId;
        });

        const com = communitiesArray.communities[communityIndex];
        if (com) {
          com.IsCompare = true;
        }
      }

      if(isLocalhost()) {
        toggleCompare(communityId);
        updatePropCount();
      } else {
        fetch(compareManageUrl + communityId, {
          method: 'POST',
        })
          .then(_ => {
            toggleCompare(communityId);
            updatePropCount();
          });
      }
    });

    const bindEvents = () => {
      document.querySelectorAll('[href="#save"]').forEach((saveLink) => {
        bindEvent(saveLink, 'click', handleSaveEvent);
      });

      document.querySelectorAll('[href="#remove"]').forEach((removeLink) => {
        bindEvent(removeLink, 'click', handleRemove);
      });

      document.querySelectorAll('[href="#add"]').forEach((addLink) => {
        bindEvent(addLink, 'click', handleAdd);
      });

      document.querySelectorAll(".community-list__item--link").forEach((itemLink) => {
        bindEvent(itemLink, 'click', handleClick);
      });
    };

    document.addEventListener("updateSave", ((e) => {
      if(!Object.is(savedList, null)){
        const savedEl = savedList.querySelector('[data-id="' + e.detail.Id + '"]');
        if(e.detail.IsSaved && !savedEl){
          const communityIndex = communitiesArray.communities.findIndex( obj => {
            return obj.Id === e.detail.Id;
          });
          const li = buildListItem(communitiesArray.communities[communityIndex]);

          bindEvent(li.querySelector('[href="#save"]'), 'click', handleSaveEvent);
          bindEvent(li.querySelector('[href="#remove"]'), 'click', handleRemove);
          bindEvent(li.querySelector('[href="#add"]'), 'click', handleAdd);

          savedList.appendChild(li);
        } else {
          if(!Object.is(savedEl, null)) savedEl.remove();
        }
      }
    }));

    // LOAD Viewed
    const buildCommunityList = () => {
      let propertyCount = 0;
      communitiesArray.communities.forEach((property) => {
        let li = buildListItem(property);

        if(property.IsRecent) {
          viewedList.appendChild(li.cloneNode(true));
        }

        if(property.IsSaved) savedList.appendChild(li.cloneNode(true));
        if(property.IsCompare) compareList.appendChild(li.cloneNode(true));

        propertyCount++;
      });

      viewedList.setAttribute('data-count', propertyCount)
      viewedList.classList.remove('loading');

      savedList.setAttribute('data-count', propertyCount)
      savedList.classList.remove('loading');

      compareList.setAttribute('data-count', propertyCount)
      compareList.classList.remove('loading');

      updatePropCount();
      bindEvents();
    };

    buildCommunityList();
  }

  document.addEventListener("addedToCompare", (e) => {
    if (compareWrapper) {
      let li = buildListItem(e.detail, false);
      compareList.appendChild(li);
    }
  });

  document.addEventListener("removeFromCompare", (e) => {
    const { Id } = e.detail;
    if (Id && compareWrapper) {
      const target = compareWrapper.querySelector(`li[data-id="${Id}"]`);
      if (target) {
        target.remove();
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/templates/components/compare-communities/compare-communities.js